module.exports = __webpack_public_path__ + "static/stage1-thumb-eb17923a4a3e178c983ff6de72f43f00.jpg";